import Vue from 'vue'

/**
 * Register global components here
 */

Vue.component('v-deploy', () => import('./components/deploy/index.vue'))
